import angular from 'angular'



// checkBillDetail *************************
const listPage =  require('./view/list.html')
// const listCtrl =  require('./list')
import listCtrl from './list'


function configRouter ($stateProvider) {
    $stateProvider.state(
        'outputManage.FOManage.invoiceException',
        {
            url: '/invoiceException',
            abstract: true,
            template: '<div ui-view></div>',
            default: 'outputManage.FOManage.invoiceException.list',
            title: '异常发票',
        },
    )
    $stateProvider.state(
        'outputManage.FOManage.invoiceException.list',
        {
            url: '/list',
            template: listPage,
            controller: 'invoiceExceptionListCtrl',
        },
    )
}

export default angular
    .module('outputManage.FOManage.invoiceException', [])
    .config(['$stateProvider', configRouter])
    .controller('invoiceExceptionListCtrl', listCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoiceException/index.js